import React from 'react';
import { StarFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Rate } from 'antd';

import { useGetRatingQuery, useSaveRatingMutation } from '@/services/lesson';
import styled, { StyledProp } from '@/styled';

function Stars({ className }: StyledProp) {
  const { id } = useParams();
  const rating = useGetRatingQuery(id);
  const [save] = useSaveRatingMutation();

  const handleSubmitRating = (rating: number) => {
    save({ lessonId: id, rating });
  };

  return (
    <Rate
      defaultValue={rating.data?.user_rating}
      onChange={handleSubmitRating}
      rootClassName={className}
      character={<StarFill />}
      value={rating.data?.user_rating}
    />
  );
}

export default styled(Stars)`
  margin-top: ${({ theme }) => theme.space.pxToRem(24)};

  svg {
    font-size: ${({ theme }) => theme.space.pxToRem(24)};
    color: ${({ theme }) => theme.palette.gray[6]};
  }

  *[aria-checked='true'] {
    svg {
      color: ${({ theme }) => theme.colorText};
    }
  }
`;
